// Time-of-day theme: 07:00–18:59 local = sapphire day mode; otherwise royal purple night
export const IS_DAY = (() => {
  const h = new Date().getHours();
  return h >= 7 && h < 19;
})();

export const ACCENT = IS_DAY
  ? { main: "#3B82F6", deep: "#1D4ED8", light: "#93C5FD", mainHex: 0x3b82f6, deepHex: 0x1d4ed8 }
  : { main: "#A855F7", deep: "#7C3AED", light: "#D8B4FE", mainHex: 0xa855f7, deepHex: 0x7c3aed };
